import Box from '@mui/material/Box';

// project imports
import Navigation from './Navigation';
import DrawerBuildInfo from './DrawerBuildInfo';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <SimpleBar
        sx={{
          flex: 1,
          minHeight: 0,
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100%'
          }
        }}
      >
        <Navigation />
        <DrawerBuildInfo />
      </SimpleBar>
    </Box>
  );
}
